/* eslint-disable vue/require-v-for-key */
/* eslint-disable vue/require-default-prop */
<template>
  <div class="mb-5 pb-5">
    <div class="col-md-12" v-show="type == 'produto'">
      <!-- Campo de Pesquisa -->

      <div class="row mt-4">
        <b-form-input v-model="searchQuery" placeholder="Digite o nome do produto..."></b-form-input>
      </div>

      <!-- Cartões de Produtos -->
      <div class="row cards-container">
        <div class="card produto-card" v-for="produto in paginatedProdutos" :key="produto.idProduto">
          <div class="card-body">
            <h5 class="card-title">{{ produto.nomeProduto }}</h5>
            <p class="card-text">
              <strong>Número do Registro no MAPA:</strong>
              {{ produto.registroMapa }}
            </p>
            <p class="card-text">
              <strong>Pragas combatidas:</strong>
              {{ produto.pragasCombatidas }}
            </p>
          </div>
          <div class="card-footer">
            <button class="btn btn-success" @click="abrirModal(produto.idProduto)">Acesse →</button>
          </div>
        </div>
      </div>

      <!-- Paginação -->
      <div class="pagination-container" v-if="filteredProdutos.length > itemsPerPage">
        <b-pagination v-model="currentPage" :total-rows="filteredProdutos.length" :per-page="itemsPerPage"
          aria-controls="cards-container"></b-pagination>
      </div>
    </div>

    <!-- Modal de Detalhes -->
    <b-modal id="produtoModal" :title="'Detalhes do Produto'" hide-footer size="lg">
      <div v-if="produtoSelecionado">
        <p><strong>Produto:</strong> {{ relacoes[0].nome }}</p>
        <p><strong>Pragas combatidas:</strong> {{ relacoes.length }}</p>
        <p><strong>Classe Toxicológica:</strong> {{ relacoes[0].classeToxicologica }}</p>
        <p><strong>Ingrediente Ativo:</strong> {{ relacoes[0].ingredientes.join(', ') }}</p>
        <div v-if="relacoes.length">
          <h5 class="mt-4">Indicações de Uso</h5>
          <b-table striped hover small :items="relacoes" :fields="relacoesFields" responsive
            class="table-container mt-4">
            <template v-slot:cell(nomeComumCultura)="row">
              {{ row.item.nomeComumCultura }}
            </template>
            <template v-slot:cell(nomeComumPraga)="row">
              {{ row.item.nomeComumPraga }} - <i>{{ row.item.nomeCientificoPraga }}</i>
            </template>
            <template v-slot:cell(tipoAplicacao)="row">
              {{ row.item.tipoAplicacao }}
            </template>
          </b-table>
        </div>
      </div>
      <div v-else>
        <p>Carregando...</p>
      </div>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('produtoModal')">Fechar</b-button>
      </template>
    </b-modal>
    <b-overlay :show="isLoading" no-wrap></b-overlay>
  </div>
</template>

<script>
import Layout from '@layouts/main'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mask } from 'vue-the-mask'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/pt-br'
import 'vue2-datepicker/index.css'
import receitaService from '@/src/services/receita'
import cadIngredienteAtivoService from '@/src/services/cad-ingrediente-ativo'
import ingredienteAtivoService from '@/src/services/ingrediente-ativo'
import moment from 'moment'
import ItemReceita from '../services/request/item-receita'

moment.locale('pt-br')

/**
 * Produtor rural Component
 */
export default {
  directives: { mask },
  components: {
    Layout,
    Loading,
    DatePicker,
  },
  props: {},
  data() {
    return {
      type: 'produto',
      idItemReceita: null,
      receitas: [],
      alvos: [],
      produtos: [],
      culturas: [],
      ingredientes: [],
      produtores: [],
      agronomos: [],
      relacoes: [],
      itens: [],
      produtorSelecionado: {},
      agronomoSelecionado: {},
      itemReceita: null,
      relacaoSelecionada: null,
      mostraForm: true,
      relatorioReceita: {},
      idReceita: null,
      isLoading: false,
      rows: 0,
      itensReceita: [ItemReceita],

      id_cultura: 0,
      id_produto: 0,
      id_ingrediente_ativo: 0,
      modalDelItem: false,
      titleModalRelacao: '',
      dataEmissaoReceituario: new Date(),
      isVersionProductOrCulture: 'isAll',
      relacaoCulturaFields: [
        {
          key: 'nomeComumCultura',
          label: 'Cultura',
          class: 'size-col-20',
        },
      ],
      relacaoProdutoFields: [
        {
          key: 'nome',
          label: 'Produto',
          class: 'size-col-20',
        },
      ],
      searchQuery: "",
      currentPage: 1,
      itemsPerPage: 10,
      produtoSelecionado: null,
      relacoesFields: [
        { key: "nomeComumCultura", label: "Cultura", sortable: true },
        { key: "nomeComumPraga", label: "Alvo", sortable: true },
        { key: "tipoAplicacao", label: "Tipo de aplicação", sortable: true },
      ],
    }
  },
  computed: {
    filteredProdutos() {
      return this.produtos.filter((produto) =>
        produto.nomeProduto.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    paginatedProdutos() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredProdutos.slice(start, end);
    },
  },
  watch: {
    type(value) {
      if (value === 'cultura') {
        this.id_produto = 0
        this.id_ingrediente_ativo = 0
        this.handleConsultarCultura()
        return
      }
      if (value === 'ingrediente') {
        this.id_produto = 0
        this.id_cultura = 0
        this.handleConsultarIngredienteAtivo()
        return
      }
      this.id_cultura = 0
      this.id_ingrediente_ativo = 0
      this.handleConsultarProduto()
    },
  },
  async mounted() {
    this.handleConsultarProduto()
  },
  methods: {
    updateSelect() {
      this.$forceUpdate()
    },
    formatDate(date) {
      return moment.utc(date).format('DD/MM/YYYY')
    },
    handleConsultarIngredienteAtivo() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      ingredienteAtivoService
        .listar(token)
        .then((resposta) => {
          this.isLoading = false
          this.ingredientes = resposta.data.dados
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    handleConsultarProduto() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      receitaService
        .consultarProduto(token)
        .then((resposta) => {
          this.isLoading = false
          this.produtos = resposta.data.produto
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    handleConsultarCultura() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      receitaService.consultarCultura(token).then((resposta) => {
        this.culturas = resposta.data.cultura
        this.isLoading = false
      })
    },
    abrirModal(idProduto) {
      this.relacoes = [];
      this.isLoading = true;
      receitaService
        .consultaFitossanitaria(this.$store.state.auth.currentUser.token, idProduto)
        .then((resposta) => {
          this.relacoes = resposta.data;
          this.relacoes.sort((a, b) => {
            const nomeA = a.nomeComumCultura.toLowerCase() || '';
            const nomeB = b.nomeComumCultura.toLowerCase() || '';

            return nomeA.localeCompare(nomeB, 'pt-BR', { sensitivity: 'base' });
          });
          this.produtoSelecionado = this.produtos.find((p) => p.idProduto === idProduto);
          this.$bvModal.show("produtoModal");
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    fecharModal() {
      this.produtoSelecionado = null;
    },
  },
}
</script>

<style lang="scss">
.cards-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  padding: 20px 0;
}

.produto-card {
  border: 1px solid #ddd;
  border-radius: 12px;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.3s;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }

  .card-body {
    padding: 20px;

    .card-title {
      font-size: 18px;
      margin-bottom: 15px;
      color: #333;
    }

    .card-text {
      font-size: 14px;
      color: #555;
      margin: 5px 0;

      strong {
        color: #333;
      }
    }
  }

  .card-footer {
    background-color: #f1f1f1;
    padding: 15px;
    text-align: center;

    .btn-success {
      width: 100%;
      background-color: #007661;
      color: white;
      font-size: 16px;
      font-weight: bold;
      border: none;
      border-radius: 10px;
      padding: 10px 30px;
      transition: background-color 0.3s, transform 0.2s;

      &:hover {
        background-color: #218838;
        transform: scale(1.05);
      }
    }
  }
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;

  .page-item.active .page-link {
    background-color: #007661;
    border-color: #007661;
  }

  .page-link {
    color: #007661;
    font-weight: bold;
    transition: background-color 0.3s;

    &:hover {
      background-color: #218838;
      color: white;
    }
  }
}

b-form-input {
  border-radius: 10px;
  border: 1px solid #ddd;
  padding: 10px;
  font-size: 16px;
}

.table-container {
  max-height: 400px;
  /* Define a altura máxima */
  min-height: 200px;
  /* Define a altura mínima */
  overflow-y: auto;
  /* Ativa o scroll vertical */
  border: 1px solid #ddd;
  /* Adiciona uma borda para delimitar o scroll */
  border-radius: 8px;
  /* Bordas arredondadas */
  padding: 10px;
  /* Espaçamento interno */
  background-color: #fff;
  /* Fundo branco */
}

.b-table {
  margin-bottom: 0;
  /* Remove margens externas desnecessárias */
}
</style>
